
































import { defineComponent } from '@vue/composition-api'
import { Input, Button } from 'element-ui'
import appealSetup from '../logic'
import props from '../props'
export default defineComponent({
  name: 'appealDialog',
  props,
  components: {
    ElInput: Input,
    ElButton: Button
  },
  setup: appealSetup
})
